import type { ApolloError } from '@apollo/client';
import { useHirerAccountBillingDetailsQuery } from '../generated/graphql-types';
import { AppError } from '../utils/error';
import { getLogger } from '../utils/logger/logger';
import { useQueryAccountInfo } from './useQueryAccountInfo';

export const useBillingAddress = () => {
  const { accountInfo } = useQueryAccountInfo();

  const { data, loading, error } = useHirerAccountBillingDetailsQuery({
    variables: {
      advertiserId: parseInt(
        accountInfo?.currentAdvertiser?.billingId || '',
        10,
      ),
    },
    skip: !Boolean(accountInfo?.currentAdvertiser?.billingId),
    onError: (apolloError: ApolloError) => {
      getLogger().error(apolloError.message, {
        activity: 'getHirerAccountBillingDetails',
        error: new AppError('HIRER_ACCOUNT_QUERY_ERROR', apolloError.message),
      });
    },
  });

  return {
    loading: loading || !Boolean(accountInfo?.currentAdvertiser?.billingId),
    seekBillingAccountId: data?.hirerAccount?.billingAccountId,
    businessAddress: data?.hirerAccount?.billingAddress,
    error,
  };
};
